// Development tenant notification banner is disabled in this self-hosted build.
const DevelopmentTenantNotification = () => null;

export default DevelopmentTenantNotification;
